/* RESPONSIBLE TEAM: team-inbox-management */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import { OutboundInitialPartSenderType } from 'embercom/objects/inbox/outbound-initial-part-sender-types';
import Tag, { type TagWireFormat } from 'embercom/objects/inbox/tag';
import { tracked } from '@glimmer/tracking';

interface SmsWireFormat {
  renderable_type: RenderableType;
  sender_type: OutboundInitialPartSenderType;
  blocks: Array<object>;
  tags: Array<TagWireFormat>;
  ruleset_id?: number;
  selection_set_id?: number;
}

export default class Sms implements RenderableData {
  readonly renderableType = RenderableType.Sms;
  readonly senderType: OutboundInitialPartSenderType;
  readonly blocks: Array<object>;
  @tracked tags: Array<Tag>;
  readonly rulesetId?: number;
  readonly selectionSetId?: number;

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  get styles() {
    let styles = {
      textColor: 'text-default',
      backgroundColor: 'bg-beta-container',
    };
    if (this.senderType === OutboundInitialPartSenderType.Bot) {
      styles.backgroundColor = 'bg-beta-container-emphasis';
    }

    return {
      ...styles,
      backgroundColorHover: 'bg-beta-container-emphasis',
    };
  }

  constructor(
    blocks: Array<object>,
    senderType: OutboundInitialPartSenderType,
    tags?: Array<Tag>,
    rulesetId?: number,
    selectionSetId?: number,
  ) {
    this.blocks = blocks;
    this.senderType = senderType;
    this.tags = tags || [];
    this.rulesetId = rulesetId;
    this.selectionSetId = selectionSetId;
  }

  static deserialize(json: SmsWireFormat): Sms {
    return new Sms(
      json.blocks,
      json.sender_type,
      json.tags && json.tags.map(Tag.deserialize),
      json.ruleset_id,
      json.selection_set_id,
    );
  }
}
